import { useNavigate } from 'react-router-dom';
import { CreateWorkspaceForm } from '@/components/workspace';

export function CreateWorkspacePage() {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate('/app/workspace/settings');
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <div className="p-6 md:p-8 w-full animate-fade-in">
            <div className="max-w-[600px] mx-auto pt-8">
                <CreateWorkspaceForm
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}
